import { render, staticRenderFns } from "./FollowedTags.vue?vue&type=template&id=11b40d3e"
import script from "./FollowedTags.vue?vue&type=script&lang=js"
export * from "./FollowedTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports